import { Container, Stack, Typography, useTheme } from '@mui/material';
import { MotionViewport } from 'src/components/animate';
import { useResponsive } from 'src/hooks/use-responsive';
import { useLocales } from 'src/locales';
import TeamAdvisor from '../team-advisor';
import TeamOperation from '../team-operation';

function TeamView() {
  const { t } = useLocales();
  const theme = useTheme();

  const mdDown = useResponsive('down', 'md');

  return (
    <Container component={MotionViewport}>
      <Stack py={mdDown ? 6 : 12}>
        <Typography
          fontSize={mdDown ? 20 : 30}
          sx={{ '& > span': { color: theme.palette.primary.main } }}
          textAlign="center"
        >
          {t('string_089.1')} <span>{t('string_089.2')}</span> {t('string_089.3')}{' '}
          <span>{t('string_089.4')}</span> {t('string_089.5')} <span>{t('string_089.6')}</span>{' '}
          {t('string_089.7')} <span>{t('string_089.8')}</span>
        </Typography>

        <Stack spacing={6}>
          <TeamAdvisor />
          <TeamOperation />
        </Stack>
      </Stack>
    </Container>
  );
}

export default TeamView;
